import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";

const MentalHealth = () => {
  return (
    <Box sx={{ py: 0.5 }}>
      <Card>
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#f8f9fa", // replace with your theme's header color
            px: 2,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "primary.main",
              fontWeight: 800, // fw-bolder
            }}
          >
            Consent, Mental Capacity and Best Interests
          </Typography>
        </Box>

        {/* Body */}
        <CardContent sx={{ backgroundColor: "#ffffff" /* card-body-color */ }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography>Nothing Found</Typography>
            </Grid>
            {/* 
            <Grid item xs={12}>
              <Typography>08/03/2022</Typography>
            </Grid> 
            */}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MentalHealth;